import React from 'react';
import { noop } from 'lodash';
import { Styles } from 'utils/types/react';

export interface TextInputProps {
  name: string;
  value?: string | number;
  errorMessage?: string;
  touched?: boolean;
  wasSubmitted?: boolean;
  description?: string;
  label?: string;
  onBlur: Function;
  onChange?: Function;
  onFocus?: Function;
  noUnderline?: boolean;
  placeholder?: string;
  iconLeft?: React.ReactNode | Function;
  iconRight?: React.ReactNode | Function;
  disabled?: boolean;
  primary?: boolean;
  secondary?: boolean;
  withForm?: boolean;
  style?: Styles;
  forwardedRef?: React.Ref<HTMLInputElement>;
}

export function useTextInput(props: TextInputProps) {
  const [isFocused, setFocus] = React.useState(false);

  function handleBlur(event) {
    event.persist();
    setFocus(false);
    props.onBlur(event);
  }

  function handleFocus(event) {
    event.persist();
    setFocus(true);
    if (props.onFocus) {
      props.onFocus(event);
    }
  }

  const { onChange, value, ...rest } = props;

  const disabledProperties = {
    editable: false,
    // Override onChange because when input is disabled we don't want onChange to fire
    onChangeText: noop,
    onFocus: noop,
    isFocused: false,
  };

  return {
    ...rest,
    invalid:
      (Boolean(props.errorMessage) && props.touched) ||
      (props.wasSubmitted && Boolean(props.errorMessage)),
    // Because of usage withForm hoc we remap onChangeText to onChange so that we are able to use withForm with TextInput, Switch, Select/Picker, Checkbox group and etc via onChange
    onChangeText: onChange,
    hasIcon: Boolean(props.iconLeft || props.iconRight),
    hasPlaceholder: props.placeholder && !value,
    isFocused,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ...(props.disabled ? disabledProperties : {}),
    ...(value ? { value: String(value) } : {}),
  };
}
